import React, { useEffect } from "react";
import clsx from "clsx";

import { PAGINATE_SEPARATOR } from "../constants";

const Pagination = ({ total, pageNo, pageSize, onChange = () => {} }) => {
  const lastPage = Math.ceil(total / pageSize);

  const getPagination = (c) => {
    let current = c,
      m = lastPage,
      delta = 1,
      left = current - delta,
      right = current + delta + 1,
      range = [],
      rangeWithDots = [],
      l;

    range.push(1);

    if (m <= 1) return range;

    for (let i = c - delta; i <= c + delta; i++) {
      if (i >= left && i < right && i < m && i > 1) {
        range.push(i);
      }
    }

    range.push(m);

    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push(PAGINATE_SEPARATOR);
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  };

  const pages = getPagination(pageNo);

  useEffect(() => {
    onChange("totalPages", lastPage);
  }, [total]);

  return (
    <div className="datatable_pagination">
      <ul>
        <li
          onClick={() => onChange("pageNo", 1)}
          className={clsx({ disabled: pageNo === 1 })}
        >
          First
        </li>
        {pages.map((page, index) => (
          <li
            onClick={() => onChange("pageNo", page)}
            className={clsx({
              disabled: page === PAGINATE_SEPARATOR,
              active: pageNo === page,
            })}
            key={index}
          >
            {page}
          </li>
        ))}
        <li
          onClick={() => onChange("pageNo", lastPage)}
          className={clsx({ disabled: pageNo === lastPage })}
        >
          Last
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
